import React, { useState, useEffect, useRef } from 'react'
import '../assets/style.css'
import Config from '../core/config/'
import {
  makeRequest,
  makeRequestWithErrorMessage
} from '../core/services/v1/request'
import $ from 'jquery'
import NavbarOne from './separate/NavbarOne'
import FuturesMenu from './separate/futuresTrading/FuturesMenu'
import FuturesOrderBook from './separate/futuresTrading/FuturesOrderBook'
import FuturesRecent from './separate/futuresTrading/FuturesRecent'
import { showNumber, showPairNameUsdt } from '../core/helper/date-format'
import { useContextData } from '../core/context'
import { toast } from '../core/lib/toastAlert'
import FuturesMyOrders from './separate/futuresTrading/FuturesMyOrders'
import { getCookie } from '../core/helper/cookie'
import socketIOClient from 'socket.io-client'
import FuturesTradeForm from './separate/futuresTrading/FuturesTradeForm'
import TradingViewFutures from './separate/futuresTrading/tradeChartFutures/trading-view-futures'
import Info from './separate/futuresTrading/info/Info'
import TradingData from './separate/futuresTrading/TradingData'
import OrderConfirmation from './separate/futuresTrading/dialogs.js/OrderConfirmation'
import ModifyOrder from './separate/futuresTrading/dialogs.js/ModifyOrder'
import AdjustLeverage from './separate/futuresTrading/dialogs.js/AdjustLeverage'
import MarginMode from './separate/futuresTrading/dialogs.js/MarginMode'
import axios from 'axios'
import ModifyMargin from './separate/futuresTrading/dialogs.js/ModifyMargin'
import { Typography } from '@mui/material'
import LoaderSpin from '../Component/Loader/LoaderSpin'
import LoaderUnitic from '../Component/Loader/LoaderUnitic'
import { countDecimals } from '../core/helper/common'
import PageTitleDes from '../core/support/PageTitleDes'
import { createTradingAccount } from '../core/context/helper'

function removeUSDTM(inputString) {
  const regex = /USDT/g
  const result = inputString.replace(regex, '')
  return result
}
function formatNumber(number = 0) {
  if (number == 0) return 0
  const absNumber = Math.abs(number)
  const suffixes = ['', 'K', 'M', 'B', 'T']
  const suffixNum = Math.floor(('' + absNumber).length / 3)
  const shortNumber = parseFloat(
    (suffixNum !== 0
      ? absNumber / Math.pow(1000, suffixNum)
      : absNumber
    ).toPrecision(3)
  )
  const result = shortNumber + suffixes[suffixNum]
  return (number < 0 ? '-' : '') + result
}
function createSymbolMap(symbolArray = null) {
  return symbolArray.reduce((map, symbolData) => {
    map[symbolData.symbol] = symbolData
    return map
  }, {})
}
function decimalValue(value, decimal = 0) {
  if (decimal === 0) {
    return showNumber(parseFloat(value))
  }
  return showNumber(parseFloat(value).toFixed(decimal))
}
function generateId() {
  return (
    '_futures_' + Date.now() + (Math.random() * 365).toString(16).slice(4, 14)
  )
}

function getPrefixTopic(topic) {
  if (!topic) return ''
  return topic.split(':')[0]
}
const initialState = {
  bids: [],
  asks: [],
  ts: 0
}
const initialBackPages = {
  openOrders: false,
  stopOrders: false,
  orders: false,
  positions: false,
  pnl: false,
  fills: false
}
const FuturesTrade = props => {
  const [orderListType, setOrderListType] = useState('all')
  const containerRef = useRef(null)
  const containerSecondRef = useRef(null)
  const [pairDetails, setPairDetails] = useState({
    prevPrice: 0,
    data: [],
    baseDecimal: null,
    quoteDecimal: null,
    fees: {}
  })
  const [isOverflowing, setIsOverflowing] = useState(false)
  const [isOverflowingSecond, setIsOverflowingSecond] = useState(false)
  const [currentPage_tradeHis, setCurrentPage_tradeHis] = useState(1)
  const [socketConnection, setSocketConnection] = useState(null)
  const [tradesShow, setTradesShow] = useState(0)
  const [firstOptionPart, setFirstOptionPart] = useState(0)
  const [pairsData, setPairsData] = useState([])
  const [symbolsData, setSymbols] = useState([])
  const [pairsLoader, setPairsLoader] = useState(true)
  const [orderFetchLoading, setOrderFetchLoading] = useState(true)
  const [priceStatic, setPriceStatic] = useState()
  const [orderBookData, setOrderBookData] = useState(initialState)
  const [recentTradesData, setRecentTradesData] = useState({})
  const wsRef = useRef(null);
  const wsRefPvt = useRef(null);
  const pingRef = useRef(null);
  const reconnectRef = useRef(0);
  const orderBookRef = useRef(initialState);
  const [walletData, setWalletData] = useState([])
  const [trades, setTrades] = useState({
    openOrders: [],
    stopOrders: [],
    orders: [],
    positions: [],
    pnl: [],
    fills: []
  })
  const [tradesBackPage, setTradesPages] = useState(initialBackPages)
  const [crossMenu, setCrossMenu] = useState('isolated')
  const [xMenu, setXMenu] = useState(1)
  const [tpPx, setTpPx] = useState()
  const [slPx, setSlPx] = useState()
  const [time, setTime] = useState(20011860) // Time in milliseconds
  const [formattedTime, setFormattedTime] = useState('')
  const [amount, setAmount] = useState(null)
  const [openOrderConfirmation, setOpenOrderConfirmation] =
    React.useState(false)
  const [tradeParams, setTradeParams] = React.useState({})
  const [favs, setFavs] = useState(null)

  // const { pairName } = useParams();
  const { pairName, handleNavigation, navigate } = props
  const handleClickOpenOrderConfirmation = tradeParams => {
    setTradeParams(() => tradeParams)
    setOpenOrderConfirmation(true)
  }
  const handleCloseOrderConfirmation = () => {
    setOpenOrderConfirmation(false)
  }
  const [openModifyOrder, setOpenModifyOrder] = React.useState(false)

  const handleClickOpenModifyOrder = () => {
    setOpenModifyOrder(true)
  }
  const handleCloseModifyOrder = () => {
    setOpenModifyOrder(false)
  }
  const [openModifyMargin, setOpenModifyMargin] = React.useState(false)

  const handleClickOpenModifyMargin = () => {
    setOpenModifyMargin(true)
  }
  const handleCloseModifyMargin = () => {
    setOpenModifyMargin(false)
  }
  const [openAdjust, setOpenAdjust] = React.useState(false)

  const handleClickOpenAdjust = () => {
    setOpenAdjust(true)
  }
  const handleCloseAdjust = () => {
    setOpenAdjust(false)
  }
  const [openMarginMode, setOpenMarginMode] = React.useState(false)

  const handleClickOpenMarginMode = () => {
    setOpenMarginMode(true)
  }
  const handleCloseMarginMode = () => {
    setOpenMarginMode(false)
  }
  const {
    myProfile,
    setUserProfile,
    p2pSettings,
    futuresBalance,
    setFuturesBalance,
    dispatch
  } = useContextData()
  const formatSymbolName = (baseCurrency = '', quoteCurrency = '') => {
    if (baseCurrency === 'XBT') {
      baseCurrency = 'BTC'
    }
    const quoteCurrencyEdition = (
      <span style={{ color: '#C8C8C8' }}>{quoteCurrency}</span>
    )
    const symbolEdition = (
      <span className='fw-bold text-capitalize'>
        {baseCurrency + ' Perpetual/'}
        {quoteCurrencyEdition}
      </span>
    )
    return symbolEdition
  }
  const getBaseAndTargetCurrency = (symbol = '') => {
    const getOne = pairsData.find(data => data.symbol === symbol)
    let getSymbol = symbolsData?.[symbol]
    if (!getSymbol) {
      axios.get(`${Config?.V2_API_URL}trade-futures/get-symbol/${symbol}`)
        .then(res => {
          getSymbol = res.data?.symbol
        })
    }
    const modSymbol = showPairNameUsdt(symbol, '-')?.split('-');
    const bsCurr = getSymbol?.baseCoin || modSymbol?.[0]
    const qotCurr = getSymbol?.quoteCoin || modSymbol?.[1]
    const getForm = formatSymbolName(
      bsCurr,
      qotCurr
    )
    return {
      baseCurrency: bsCurr || '',
      quoteCurrency: qotCurr || '',
      currency: getForm,
      pair: { ...getOne, ...getSymbol },
      price: Number(getOne?.lastPrice),
      lastPrice: Number(getOne?.lastPrice)
    }
  }
  function getOrderValue(order) {
    if (Number(order?.cumExecValue) > 0) {
      return Number(order?.cumExecValue);
    }
    if (Number(order?.leavesValue) > 0) {
      return Number(order?.leavesValue);
    }
    return Number(order?.price) * Number(order?.qty);
  }

  const asksModify = async (a1, a2) => {
    const depthMap = new Map()
    let totalQty = 0

    a1.forEach(([price, qty]) => {
      const quantity = parseFloat(qty)
      totalQty += quantity
      depthMap.set(price, [
        price,
        quantity,
        totalQty
      ])
    })

    a2.forEach(([price, qty]) => {
      const quantity = parseFloat(qty)

      if (quantity === 0) {
        depthMap.delete(price)
      } else {
        depthMap.set(price, [
          price,
          quantity,
          0 // temp
        ])
      }
    })

    // recalc cumulative
    let cumulative = 0
    const result = Array.from(depthMap.values())
      .sort((a, b) => parseFloat(a[0]) - parseFloat(b[0]))
      .map(([price, qty]) => {
        cumulative += qty
        return [
          price,
          qty.toFixed(3),
          cumulative.toFixed(3)
        ]
      })

    return result
  }
  const bidsModify = async (a1, a2) => {
    const depthMap = new Map()
    let totalQty = 0

    a1.forEach(([price, qty]) => {
      const quantity = parseFloat(qty)
      totalQty += quantity
      depthMap.set(price, [
        price,
        quantity,
        totalQty
      ])
    })

    a2.forEach(([price, qty]) => {
      const quantity = parseFloat(qty)

      if (quantity === 0) {
        depthMap.delete(price)
      } else {
        depthMap.set(price, [
          price,
          quantity,
          0
        ])
      }
    })

    let cumulative = 0
    const result = Array.from(depthMap.values())
      .sort((a, b) => parseFloat(b[0]) - parseFloat(a[0]))
      .map(([price, qty]) => {
        cumulative += qty
        return [
          price,
          qty.toFixed(3),
          cumulative.toFixed(3)
        ]
      })

    return result
  }
  const orderBookDataCalculation = async (
    oldBids,
    oldAsks,
    newBids,
    newAsks
  ) => {
    try {
      const modifiedBids = await bidsModify(oldBids, newBids)
      const modifiedAsks = await asksModify(oldAsks, newAsks)
      orderBookRef.current = {
        bids: modifiedBids,
        asks: modifiedAsks
      };
      setOrderBookData(() => {
        return {
          bids: modifiedBids,
          asks: modifiedAsks
        }
      })
    } catch (error) {
      console.error('Error modifying data:', error)
      setOrderBookData(() => {
        return {
          bids: [],
          asks: []
        }
      })
    }
  }
  const pairDataFetch = async () => {
    setPairsLoader(true)
    await axios
      .get(`${Config?.V2_API_URL}trade-futures/get-pair?pair=${pairName}`)
      .then(res => {
        if (res.data?.data?.orderBook.retCode != 0) {
          toast({
            type: 'error',
            message: res.data?.data?.orderBook?.retMsg || 'An error ocurred!'
          })
          return handleNavigation('BTCUSDT')
        }
        const newAsks = res.data?.data?.orderBook?.result?.a || []
        const newBids = res.data?.data?.orderBook?.result?.b || []
        const oldBids = orderBookData?.bids || []
        const oldAsks = orderBookData?.asks || []
        orderBookDataCalculation(oldBids, oldAsks, newBids, newAsks)
        setRecentTradesData(() => res.data?.data?.recentTrade?.result?.list)
        setTime(() => res.data?.data?.pair?.data?.nextFundingTime)
        setPriceStatic(() => res.data?.data?.pair?.data?.lastPrice)
        const getQuoteDecimal = countDecimals(
          res.data?.data?.pair?.data?.priceFilter?.tickSize
        )
        const getBaseDecimal = countDecimals(
          res.data?.data?.pair?.data?.lotSizeFilter?.qtyStep
        )
        setPairDetails(data => {
          return {
            prevPrice: data?.prevPrice,
            data: res.data?.data?.pair?.data,
            baseDecimal: getBaseDecimal,
            quoteDecimal: getQuoteDecimal,
            fees: res.data?.data?.fees,
          }
        })
        setPairsData(() => res.data?.data?.pairs)
        const symbols = createSymbolMap(res.data?.data?.symbols)
        setSymbols(() => symbols)
        const favAdd = (res.data?.data?.pairs).filter(data =>
          myProfile?.futuresFav?.some(fav => fav === data?.symbol)
        )
        setFavs(() => favAdd)
      })
      .catch(err => console.log(err))
      .finally(() => {
        setPairsLoader(() => false)
      })
  }
  const ordersDataFetch = async () => {
    setOrderFetchLoading(() => true)
    const params = {
      url: `${Config.V2_API_URL}trade-futures/get-orders`,
      method: 'GET'
    }
    const response = await makeRequest(params)
    if (response?.status) {
      // console.log(response?.data)
      setTradesPages(() => initialBackPages)
      setTrades(() => response?.data)
    } else {
    }
    setOrderFetchLoading(() => false)
  }
  const openOrdersDataFetch = async curr => {
    setOrderFetchLoading(() => true)
    const params = {
      url: `${Config.V2_API_URL
        }trade-futures/get-open-orders?cursor=${curr}`,
      method: 'GET'
    }
    const response = await makeRequest(params)
    if (response?.status) {
      // console.log(response?.data)
      setTrades(el => {
        return { ...el, openOrders: response?.data?.openOrders }
      })
      if (curr && curr !== '1') {
        setTradesPages(el => {
          return { ...el, openOrders: true }
        })
      }
      else {
        setTradesPages(el => {
          return { ...el, openOrders: false }
        })
      }
    } else {
    }
    setOrderFetchLoading(() => false)
  }
  const orderHistoryDataFetch = async curr => {
    setOrderFetchLoading(() => true)
    const params = {
      url: `${Config.V2_API_URL
        }trade-futures/get-orderHistory?cursor=${curr}`,
      method: 'GET'
    }
    const response = await makeRequest(params)
    if (response?.status) {
      // console.log(response?.data)
      setTrades(el => {
        return { ...el, orders: response?.data?.orders }
      })
      if (curr && curr !== '1') {
        setTradesPages(el => {
          return { ...el, orders: true }
        })
      }
      else {
        setTradesPages(el => {
          return { ...el, orders: false }
        })
      }
    } else {
    }
    setOrderFetchLoading(() => false)
  }
  const stopOrderDataFetch = async curr => {
    setOrderFetchLoading(() => true)
    const params = {
      url: `${Config.V2_API_URL
        }trade-futures/get-stopOrder?cursor=${curr}`,
      method: 'GET'
    }
    const response = await makeRequest(params)
    if (response?.status) {
      // console.log(response?.data)
      setTrades(el => {
        return { ...el, stopOrders: response?.data?.stopOrders }
      })
      if (curr && curr !== '1') {
        setTradesPages(el => {
          return { ...el, stopOrders: true }
        })
      }
      else {
        setTradesPages(el => {
          return { ...el, stopOrders: false }
        })
      }
    } else {
    }
    setOrderFetchLoading(() => false)
  }
  const pnlOrderDataFetch = async curr => {
    setOrderFetchLoading(() => true)
    const params = {
      url: `${Config.V2_API_URL
        }trade-futures/get-getPnl?cursor=${curr}`,
      method: 'GET'
    }
    const response = await makeRequest(params)
    if (response?.status) {
      // console.log(response?.data)
      setTrades(el => {
        return { ...el, pnl: response?.data?.pnl }
      })
      if (curr && curr !== '1') {
        setTradesPages(el => {
          return { ...el, pnl: true }
        })
      }
      else {
        setTradesPages(el => {
          return { ...el, pnl: false }
        })
      }
    } else {
    }
    setOrderFetchLoading(() => false)
  }
  const fillsOrderDataFetch = async curr => {
    setOrderFetchLoading(() => true)
    const params = {
      url: `${Config.V2_API_URL
        }trade-futures/get-fills?cursor=${curr}`,
      method: 'GET'
    }
    const response = await makeRequest(params)
    if (response?.status) {
      // console.log(response?.data)
      setTrades(el => {
        return { ...el, fills: response?.data?.fills }
      })
      if (curr && curr !== '1') {
        setTradesPages(el => {
          return { ...el, fills: true }
        })
      }
      else {
        setTradesPages(el => {
          return { ...el, fills: false }
        })
      }
    } else {
    }
    setOrderFetchLoading(() => false)
  }
  const positionsDataFetch = async curr => {
    setOrderFetchLoading(() => true)
    const params = {
      url: `${Config.V2_API_URL
        }trade-futures/get-positions?cursor=${curr}`,
      method: 'GET'
    }
    const response = await makeRequest(params)
    if (response?.status) {
      // console.log(response?.data)
      setTrades(el => {
        return { ...el, positions: response?.data?.positions }
      })
      if (curr && curr !== '1') {
        setTradesPages(el => {
          return { ...el, positions: true }
        })
      }
      else {
        setTradesPages(el => {
          return { ...el, positions: false }
        })
      }
    } else {
    }
    setOrderFetchLoading(() => false)
  }
  useEffect(() => {
    const favAdd = pairsData.filter(data =>
      myProfile?.futuresFav?.some(fav => fav === data?.symbol)
    )
    setFavs(() => favAdd)
  }, [myProfile, pairsData])

  useEffect(() => {
    const interval = setInterval(() => {
      setTime(prevTime => prevTime - 1000)
    }, 1000)

    return () => clearInterval(interval)
  }, [])

  useEffect(() => {
    const hours = Math.floor((time / (1000 * 60 * 60)) % 24)
    const minutes = Math.floor((time / (1000 * 60)) % 60)
    const seconds = Math.floor((time / 1000) % 60)

    // Format time as hh:mm:ss
    const formattedTimeString = `${hours.toString().padStart(2, '0')}:${minutes
      .toString()
      .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`

    setFormattedTime(() => formattedTimeString)
  }, [time])
  const checkOverflow = () => {
    if (containerRef.current && containerSecondRef.current) {
      setIsOverflowing(
        containerRef.current.scrollWidth > containerRef.current.clientWidth
      )
      setIsOverflowingSecond(
        containerSecondRef.current.scrollWidth >
        containerSecondRef.current.clientWidth
      )
    }
  }

  useEffect(() => {
    checkOverflow()

    window.addEventListener('resize', checkOverflow)
    return () => {
      window.removeEventListener('resize', checkOverflow)
    }
  }, [pairsData])
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    })
    pairDataFetch()
    ordersDataFetch()
    setFuturesBalance()
    // getWalletCurrency();
    $(document).ready(function () {
      $('.futures-trading-table-total-height li').mouseenter(function () {
        $(this).addClass('divider')
      })
      $('.futures-trading-table-total-height li').mouseleave(function () {
        $(this).removeClass('divider')
      })
    })
  }, [])

  useEffect(() => {
    let socket = socketIOClient(Config.SOCKET_URL, {
      // transports: ["polling"],
      transports: ['websocket']
      // rejectUnauthorized: false
    })
    let socketUnsubscribe
    if (socket) {
      socket.on('connect', function () {
        // console.log("socket connected");
        setSocketConnection(() => socket)
        socketUnsubscribe = socket
      })
      socket.on('connect_error', err => {
        // console.log("socket connect_error", err);
      })
      socket.on('disconnect', function () {
        // console.log("socket disconnected");
      })
    }

    return () => {
      if (socketUnsubscribe) {
        socketUnsubscribe.disconnect()
      }
    }
  }, [])
  const normalizeSymbol = (pair = "") =>
    pair.toUpperCase().replace(/[\s/_-]/g, "");

  const getTopicRoot = topic => topic?.split(".")[0] || "";
  const getTopicSymbol = topic => topic?.split(".").pop() || "";
  useEffect(() => {
    if (!pairName) return;

    const symbol = normalizeSymbol(pairName);

    const connect = () => {
      wsRef.current = new WebSocket(Config.BYBIT_SOCKET + '/linear');

      wsRef.current.onopen = () => {
        reconnectRef.current = 0;

        wsRef.current.send(
          JSON.stringify({
            op: "subscribe",
            args: [
              `tickers.${symbol}`,
              `publicTrade.${symbol}`,
              `orderbook.50.${symbol}`
            ]
          })
        );

        pingRef.current = setInterval(() => {
          if (wsRef.current?.readyState === WebSocket.OPEN) {
            wsRef.current.send(JSON.stringify({ op: "ping" }));
          }
        }, 20000);
      };

      wsRef.current.onmessage = e => {
        try {
          const msg = JSON.parse(e.data);
          if (!msg?.topic || !msg?.data) return;
          // console.log('msg ', msg)
          handleMessage(msg, symbol);
        } catch (err) {
          console.error("WS parse error", err);
        }
      };

      wsRef.current.onerror = () => wsRef.current?.close();

      wsRef.current.onclose = () => {
        clearInterval(pingRef.current);
        if (reconnectRef.current < 5) {
          reconnectRef.current++;
          setTimeout(connect, reconnectRef.current * 2000);
        }
      };
    };

    connect();

    return () => {
      clearInterval(pingRef.current);
      wsRef.current?.close();
      wsRef.current = null;
    };
  }, [pairName]);

  // useEffect(() => {
  //   wsRefPvt.current = new WebSocket(Config.BYBIT_SOCKET_PVT + '/futures?token=' + getCookie("userToken"));

  //   wsRefPvt.current.onmessage = (e) => {
  //     handleMessageV2(JSON.parse(e.data));
  //   };

  //   return () => {
  //     wsRefPvt.current?.close();
  //     wsRefPvt.current = null;
  //   };
  // }, []);
  useEffect(() => {
    let socket;
    let manuallyClosed = false;

    const connectSocket = () => {
      const token = getCookie("userToken");

      if (!token) {
        // console.error("❌ User token not found");
        return;
      }

      const socketUrl =
        Config.BYBIT_SOCKET_PVT +
        "/futures?token=" +
        encodeURIComponent(token);

      // console.log("🔌 Connecting Bybit Futures Private Socket...");

      socket = new WebSocket(socketUrl);
      wsRefPvt.current = socket;

      socket.onopen = () => {
        // console.log("✅ Bybit Futures Private Socket Connected");
      };

      socket.onmessage = (e) => {
        try {
          const data = JSON.parse(e.data);

          handleMessageV2(data);
        } catch (error) {
          // console.error(
          //   "❌ Futures Private Socket Message Parse Error:",
          //   error
          // );
        }
      };

      socket.onerror = (error) => {
        // console.error(
        //   "❌ Bybit Futures Private Socket Error:",
        //   error
        // );
      };

      socket.onclose = (event) => {
        // console.log("🔴 Bybit Futures Private Socket Closed:", {
        //   code: event.code,
        //   reason: event.reason,
        //   wasClean: event.wasClean,
        //   manuallyClosed,
        // });
      };
    };

    connectSocket();

    return () => {
      manuallyClosed = true;

      const currentSocket = socket;

      if (
        currentSocket &&
        (
          currentSocket.readyState === WebSocket.OPEN ||
          currentSocket.readyState === WebSocket.CONNECTING
        )
      ) {
        currentSocket.close(1000, "Component unmounted");
      }

      if (wsRefPvt.current === currentSocket) {
        wsRefPvt.current = null;
      }
    };
  }, []);

  const handleMessage = (msg, currentSymbol) => {
    const topicRoot = getTopicRoot(msg.topic);
    const topicSymbol = getTopicSymbol(msg.topic);

    if (topicSymbol !== currentSymbol) return;
    if (topicRoot === "orderbook") {
      const bids = msg.data?.b || [];
      const asks = msg.data?.a || [];
      if (msg.type === "snapshot" || msg.data?.u === 1) {
        orderBookDataCalculation([], [], bids, asks);
      }
      if (msg.type === "delta") {
        const prev = orderBookRef.current;
        if (!prev?.bids || !prev?.asks) return;
        orderBookDataCalculation(prev.bids, prev.asks, bids, asks);
      }
    }

    if (topicRoot === "publicTrade") {
      setRecentTradesData(prev => {
        const old = Array.isArray(prev) ? prev : [];
        const merged = [...msg.data, ...old];

        return merged
          .sort((a, b) => b.T - a.T)
          .slice(0, 18);
      });
    }

    if (topicRoot === "tickers") {
      setPairDetails(prev => {
        if (!prev?.data) return prev;

        return {
          ...prev,
          prevPrice: msg.data?.indexPrice,
          data: {
            ...prev.data,
            price: msg.data.lastPrice,
            ask1Price: msg?.data?.ask1Price || prev.data.ask1Price,
            ask1Size: msg?.data?.ask1Size || prev.data.ask1Size,
            bid1Price: msg?.data?.bid1Price || prev.data.bid1Price,
            bid1Size: msg?.data?.bid1Size || prev.data.bid1Size,
            curPreListingPhase: msg?.data?.curPreListingPhase || prev.data.curPreListingPhase,
            fundingCap: msg?.data?.fundingCap || prev.data.fundingCap,
            fundingIntervalHour: msg?.data?.fundingIntervalHour || prev.data.fundingIntervalHour,
            fundingRate: msg?.data?.fundingRate || prev.data.fundingRate,
            highPrice24h: msg?.data?.highPrice24h || prev.data.highPrice24h,
            indexPrice: msg?.data?.indexPrice || prev.data.indexPrice,
            lastPrice: msg?.data?.lastPrice || prev.data.lastPrice,
            lowPrice24h: msg?.data?.lowPrice24h || prev.data.lowPrice24h,
            markPrice: msg?.data?.markPrice || prev.data.markPrice,
            nextFundingTime: msg?.data?.nextFundingTime || prev.data.nextFundingTime,
            openInterest: msg?.data?.openInterest || prev.data.openInterest,
            openInterestValue: msg?.data?.openInterestValue || prev.data.openInterestValue,
            preOpenPrice: msg?.data?.preOpenPrice || prev.data.preOpenPrice,
            preQty: msg?.data?.preQty || prev.data.preQty,
            prevPrice1h: msg?.data?.prevPrice1h || prev.data.prevPrice1h,
            prevPrice24h: msg?.data?.prevPrice24h || prev.data.prevPrice24h,
            price24hPcnt: msg?.data?.price24hPcnt || prev.data.price24hPcnt,
            symbol: msg?.data?.symbol || prev.data.symbol,
            tickDirection: msg?.data?.tickDirection || prev.data.tickDirection,
            turnover24h: msg?.data?.turnover24h || prev.data.turnover24h,
            volume24h: msg?.data?.volume24h || prev.data.volume24h,
          },
        };
      });
    }
  };
  async function handleMessageV2(message) {
    // console.log(data)
    // dataPairName=dataPairName.split('_')[0]
    const topic = message?.topic;
    const data = message?.data;
    if (!topic || !data) return;

    if (topic === "wallet") {
      data.forEach(el => {
        el?.coin.forEach(item => {
          if (item.coin === 'USDT' && item.walletBalance) {
            dispatch({
              type: 'SET_FUTURES_BALANCE',
              payload: item
            })
          }
        })
      });
    }
    if (topic === "position.linear") {
      data.forEach(order => {
        setTrades(prev => {
          const newOrder = order;
          if (!newOrder) return prev
          const orderMap = new Map(
            prev.positions?.list.map(order => [order.symbol, order])
          )

          // Handle the new order
          if (newOrder) {
            if (newOrder.positionStatus === "Normal" && Number(newOrder.size) > 0) {
              orderMap.set(newOrder.symbol, newOrder)
            } else if (orderMap.has(newOrder.symbol)) {
              orderMap.delete(newOrder.symbol)
            }
          }

          const updatedOrders = [...orderMap.values()]

          const resultOrders =
            newOrder && newOrder.positionStatus === "Normal" && Number(newOrder.size) > 0
              ? [
                newOrder,
                ...updatedOrders.filter(
                  order => order.symbol !== newOrder.symbol
                )
              ]
              : updatedOrders

          return {
            ...prev,
            positions: { ...prev.positions, list: resultOrders }
          }
        })
      })
    }
    if (topic === "order.linear") {
      data.forEach(order => {
        setTrades(prev => {
          if (!order) return prev;
          const orderId = order.orderId;
          const status = order.orderStatus;
          const stopOrderType = order?.stopOrderType;
          //non stop
          if ((!stopOrderType || stopOrderType === "") && (status === "New" || status === "PartiallyFilled")) {
            const updatedOpenOrders = prev.openOrders?.list.some(
              o => o.orderId === orderId
            )
              ? prev.openOrders?.list.map(o =>
                o.orderId === orderId ? order : o
              )
              : [order, ...prev.openOrders?.list];

            return {
              ...prev,
              openOrders: { ...prev.openOrders, list: updatedOpenOrders }
            };
          }
          if ((!stopOrderType || stopOrderType === "") && (status === "Filled" || status === "Cancelled" || status === "PartiallyFilledCanceled" || status === "Rejected")) {
            const updatedOrders = prev.orders?.list.some(
              o => o.orderId === orderId
            )
              ? prev.orders?.list.map(o =>
                o.orderId === orderId ? order : o
              )
              : [order, ...prev.orders?.list];
            return {
              ...prev,
              openOrders: {
                ...prev.openOrders, list: prev.openOrders?.list.filter(
                  o => o.orderId !== orderId
                )
              },
              orders: { ...prev.orders, list: updatedOrders }
            };
          }

          //stop
          if ((stopOrderType === "Stop" || stopOrderType === "TakeProfit" || stopOrderType === "StopLoss" || stopOrderType === 'tpslOrder') && status === "Untriggered") {
            const updatedStopOrders = prev.stopOrders?.list.some(
              o => o.orderId === orderId
            )
              ? prev.stopOrders?.list.map(o =>
                o.orderId === orderId ? order : o
              )
              : [order, ...prev.stopOrders?.list];

            return {
              ...prev,
              stopOrders: { ...prev.stopOrders, list: updatedStopOrders }
            };
          }
          if ((stopOrderType === "Stop" || stopOrderType === "TakeProfit" || stopOrderType === "StopLoss" || stopOrderType === 'tpslOrder') && (status === "Triggered" || status === "Deactivated" || status === "Activated" || status === "Rejected")) {
            const updatedOrders = prev.orders?.list.some(
              o => o.orderId === orderId
            )
              ? prev.orders?.list.map(o =>
                o.orderId === orderId ? order : o
              )
              : [order, ...prev.orders?.list];
            return {
              ...prev,
              stopOrders: {
                ...prev.stopOrders, list: prev.stopOrders?.list.filter(
                  o => o.orderId !== orderId
                )
              },
              orders: { ...prev.orders, list: updatedOrders }
            };
          }

          return prev;
        });
      })
    }
    if (topic === "execution.fast.linear") {
      data.forEach(exec => {
        setTrades(prev => {
          if (!exec) return prev;

          const execOrderId = exec.orderId;

          const updatedFills = prev.fills?.list.some(
            f => f.execId === exec.execId
          )
            ? prev.fills?.list
            : [
              {
                execId: exec.execId,
                orderId: exec.orderId,
                symbol: exec.symbol,
                side: exec.side,
                price: +exec.execPrice,
                qty: +exec.execQty,
                time: exec.execTime
              },
              ...prev.fills?.list
            ];

          return {
            ...prev,
            fills: { ...prev.fills, list: updatedFills },
            openOrders: {
              ...prev.openOrders, list: prev.openOrders?.list.map(o =>
                o.orderId === execOrderId
                  ? {
                    ...o,
                    cumExecQty:
                      (+o.cumExecQty || 0) + +exec.execQty
                  }
                  : o
              )
            }
          };
        });
      })
    }
  }
  async function cancelOrder(data, isWait = false) {
    const params = {
      url: `${Config.V2_API_URL}trade-futures/cancel-order`,
      method: 'POST',
      body: data
    }
    const response = await makeRequest(params)
    if (response.status) {
      toast({ type: 'success', message: response.message })
      if (!isWait) {
        ordersDataFetch()
      }
      return true
    } else {
      toast({ type: 'error', message: response.message })
      return false
    }
  }
  const submitTradeWithAPI = async (tradeParam, what = 'order') => {
    if (
      myProfile &&
      ((myProfile.additionalKyc.status !== 'manually_approved' &&
        myProfile.additionalBank.status !== 'manually_approved' &&
        myProfile.additionalKyc.status !== 'auto_approved' &&
        myProfile.additionalKyc.status !== 'approved' &&
        myProfile.additionalBank.status !== 'auto_approved' &&
        myProfile.additionalBank.status !== 'approved') ||
        myProfile?.kycOffline?.aadhaar?.status != 1 ||
        myProfile?.kycOffline?.aml?.status != 1 ||
        myProfile?.kycOffline?.identity?.status != 1)
    ) {
      toast({ type: 'error', message: 'Please complete the kyc details' })
      navigate('/my/identification')
      return false
    }
    const params = {
      url: `${Config.V2_API_URL}trade-futures/submit-futures-trade?type=${what}`,
      method: 'POST',
      body: { data: tradeParam }
    }
    const response = await makeRequestWithErrorMessage(params)
    if (response.status) {
      toast({ type: 'success', message: response.message })
      setUserProfile()
      ordersDataFetch()
      // getWalletCurrency();
      return true
    } else {
      toast({ type: 'error', message: response.message })
      return false
    }
  }
  const updateFavPairs = async (name, dataSingle) => {
    const params = {
      url: `${Config.V1_API_URL}user/updateFuturesFav`,
      method: 'POST',
      body: { data: name }
    }
    const response = await makeRequest(params)

    if (response.status) {
      const profileSpotFav = myProfile?.futuresFav || []
      if (response?.isAdd === '1') {
        dispatch({
          type: "SET_MY_FUTURE_FAV",
          payload: [...profileSpotFav, name]
        });
      } else if (response?.isAdd === '0') {
        const cutDataState = profileSpotFav.filter(
          data => data !== dataSingle?.symbol
        )
        dispatch({
          type: "SET_MY_FUTURE_FAV",
          payload: cutDataState
        });
      }
      // toast({ type: "success", message: response.message });
    } else {
      // toast({ type: "error", message: response.message });
    }
  }
  const addTpSl = (tradeParams, what) => {
    submitTradeWithAPI(tradeParams, what)
  }
  const closePosition = (tradeParams, what) => {
    submitTradeWithAPI(tradeParams, what)
  }

  const fromSymbolName = baseCurrency => {
    if (!baseCurrency || baseCurrency == '') return ''
    if (baseCurrency === 'XBT') {
      baseCurrency = 'BTC'
    }
    return baseCurrency
  }

  const myOrdersDiv = (
    <div className=''>
      <FuturesMyOrders
        getOrderValue={getOrderValue}
        myProfile={myProfile}
        trades={trades}
        tradesBackPage={tradesBackPage}
        fromSymbolName={fromSymbolName}
        getBaseAndTargetCurrency={getBaseAndTargetCurrency}
        cancelOrder={cancelOrder}
        addTpSl={addTpSl}
        closePosition={closePosition}
        setCurrentPage_tradeHis={setCurrentPage_tradeHis}
        currentPage_tradeHis={currentPage_tradeHis}
        decimalValue={decimalValue}
        pairsLoader={pairsLoader}
        orderFetchLoading={orderFetchLoading}
        ordersDataFetch={ordersDataFetch}
        openOrdersDataFetch={openOrdersDataFetch}
        positionsDataFetch={positionsDataFetch}
        orderHistoryDataFetch={orderHistoryDataFetch}
        stopOrderDataFetch={stopOrderDataFetch}
        pnlOrderDataFetch={pnlOrderDataFetch}
        fillsOrderDataFetch={fillsOrderDataFetch}
      />
    </div>
  )
  const orderBooksDiv = (
    <div className='col-12 col-lg-4 col-xxl-3 h-100'>
      <div className='pt-2'>
        <div className='d-flex flex-column trading-page-top-section-2 align-items-center top-heading-total-height'>
          <div
            className='me-auto ps-2 menu-option-part-order w-100'
            style={{ gap: '10px' }}
          >
            <Typography
              component='h1'
              className={`mb-0 pt-1 pb-2 menu-option-part-order-p  ${tradesShow == 0 ? 'text-active-order' : ''
                }`}
              onClick={() => setTradesShow(() => 0)}
            >
              Order Book
            </Typography>
            <Typography
              component='h1'
              className={`mb-0 pt-1 pb-2 menu-option-part-order-p  ${tradesShow == 1 ? 'text-active-order' : ''
                }`}
              onClick={() => setTradesShow(() => 1)}
            >
              Real-Time Trades
            </Typography>
          </div>
        </div>
        {tradesShow == 0 ? (
          <div className='p-0 futures-trading-table-total-height'>
            <div className='text-end d-flex justify-content-end align-items-center orderbook-grid-tabs mt-1'>
              <ul className='nav nav-pills' id='pills-tab' role='tablist'>
                <li
                  className='nav-item'
                  role='presentation'
                  onClick={() => setOrderListType('buy')}
                >
                  <button
                    className='nav-link active'
                    id='pills-grid1-tab'
                    data-bs-toggle='pill'
                    data-bs-target='#pills-grid1'
                    type='button'
                    role='tab'
                    aria-controls='pills-grid1'
                    aria-selected='true'
                  >
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='20'
                      height='12'
                      viewBox='0 0 20 12'
                    >
                      <g
                        id='Rectangle_9'
                        data-name='Rectangle 9'
                        fill='none'
                        stroke='#20b958'
                        strokeLinecap='round'
                        strokeWidth='1'
                      >
                        <rect width='5' height='12' rx='0.5' stroke='none' />
                        <rect
                          x='0.5'
                          y='0.5'
                          width='4'
                          height='11'
                          fill='none'
                        />
                      </g>
                      <g
                        id='Rectangle_10'
                        data-name='Rectangle 10'
                        transform='translate(8 5) rotate(-90)'
                        fill='none'
                        stroke='#b3b7c2'
                        strokeLinecap='round'
                        strokeWidth='1'
                      >
                        <rect width='5' height='12' rx='0.5' stroke='none' />
                        <rect
                          x='0.5'
                          y='0.5'
                          width='4'
                          height='11'
                          fill='none'
                        />
                      </g>
                      <g
                        id='Rectangle_11'
                        data-name='Rectangle 11'
                        transform='translate(8 12) rotate(-90)'
                        fill='none'
                        stroke='#b3b7c2'
                        strokeLinecap='round'
                        strokeWidth='1'
                      >
                        <rect width='5' height='12' rx='0.5' stroke='none' />
                        <rect
                          x='0.5'
                          y='0.5'
                          width='4'
                          height='11'
                          fill='none'
                        />
                      </g>
                    </svg>
                  </button>
                </li>
                <li
                  className='nav-item'
                  role='presentation'
                  onClick={() => setOrderListType('sell')}
                >
                  <button
                    className='nav-link'
                    id='pills-grid2-tab'
                    data-bs-toggle='pill'
                    data-bs-target='#pills-grid2'
                    type='button'
                    role='tab'
                    aria-controls='pills-grid2'
                    aria-selected='false'
                  >
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='20'
                      height='12'
                      viewBox='0 0 20 12'
                    >
                      <g
                        id='Rectangle_9'
                        data-name='Rectangle 9'
                        fill='none'
                        stroke='#ff5a5a'
                        strokeLinecap='round'
                        strokeWidth='1'
                      >
                        <rect width='5' height='12' rx='0.5' stroke='none' />
                        <rect
                          x='0.5'
                          y='0.5'
                          width='4'
                          height='11'
                          fill='none'
                        />
                      </g>
                      <g
                        id='Rectangle_10'
                        data-name='Rectangle 10'
                        transform='translate(8 5) rotate(-90)'
                        fill='none'
                        stroke='#b3b7c2'
                        strokeLinecap='round'
                        strokeWidth='1'
                      >
                        <rect width='5' height='12' rx='0.5' stroke='none' />
                        <rect
                          x='0.5'
                          y='0.5'
                          width='4'
                          height='11'
                          fill='none'
                        />
                      </g>
                      <g
                        id='Rectangle_11'
                        data-name='Rectangle 11'
                        transform='translate(8 12) rotate(-90)'
                        fill='none'
                        stroke='#b3b7c2'
                        strokeLinecap='round'
                        strokeWidth='1'
                      >
                        <rect width='5' height='12' rx='0.5' stroke='none' />
                        <rect
                          x='0.5'
                          y='0.5'
                          width='4'
                          height='11'
                          fill='none'
                        />
                      </g>
                    </svg>
                  </button>
                </li>
                <li
                  className='nav-item'
                  role='presentation'
                  onClick={() => setOrderListType('all')}
                >
                  <button
                    className='nav-link'
                    id='pills-grid3-tab'
                    data-bs-toggle='pill'
                    data-bs-target='#pills-grid3'
                    type='button'
                    role='tab'
                    aria-controls='pills-grid3'
                    aria-selected='false'
                  >
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='20'
                      height='12'
                      viewBox='0 0 20 12'
                    >
                      <g
                        id='Rectangle_5'
                        data-name='Rectangle 5'
                        transform='translate(8)'
                        fill='none'
                        stroke='#b3b7c2'
                        strokeLinecap='round'
                        strokeWidth='1'
                      >
                        <rect width='12' height='5' rx='0.5' stroke='none' />
                        <rect
                          x='0.5'
                          y='0.5'
                          width='11'
                          height='4'
                          fill='none'
                        />
                      </g>
                      <g
                        id='Rectangle_7'
                        data-name='Rectangle 7'
                        transform='translate(8 7)'
                        fill='none'
                        stroke='#b3b7c2'
                        strokeLinecap='round'
                        strokeWidth='1'
                      >
                        <rect width='12' height='5' rx='0.5' stroke='none' />
                        <rect
                          x='0.5'
                          y='0.5'
                          width='11'
                          height='4'
                          fill='none'
                        />
                      </g>
                      <g
                        id='Rectangle_6'
                        data-name='Rectangle 6'
                        transform='translate(0 7)'
                        fill='none'
                        stroke='#20b958'
                        strokeLinecap='round'
                        strokeWidth='1'
                      >
                        <rect width='5' height='5' rx='0.5' stroke='none' />
                        <rect
                          x='0.5'
                          y='0.5'
                          width='4'
                          height='4'
                          fill='none'
                        />
                      </g>
                      <g
                        id='Rectangle_8'
                        data-name='Rectangle 8'
                        fill='none'
                        stroke='#ff5a5a'
                        strokeLinecap='round'
                        strokeWidth='1'
                      >
                        <rect width='5' height='5' rx='0.5' stroke='none' />
                        <rect
                          x='0.5'
                          y='0.5'
                          width='4'
                          height='4'
                          fill='none'
                        />
                      </g>
                    </svg>
                  </button>
                </li>
              </ul>
            </div>
            {pairsLoader ? (
              <div className='trading-page-top-section-3 '>
                <div className='' style={{ height: '480px' }}>
                  <div className='d-flex flex-row mb-1 mobile-justify-content orderbook-table-heading-section border-top-0'>
                    <div className='progress-table-1'>
                      <span className='orderbook-text-1'>Price(USDT)</span>
                    </div>
                    <div className='progress-table-2'>
                      <span className='orderbook-text-1'>Amount</span>
                    </div>
                    <div className='progress-table-3'>
                      <span className='orderbook-text-1'>Total</span>
                    </div>
                  </div>
                  <div className='h-100' style={{ marginTop: '-25px' }}>
                    <LoaderSpin />
                  </div>
                </div>
              </div>
            ) : (
              <div>
                <div className='trading-page-top-section-3 '>
                  <div className='trading-table-left-section exchange-progress-bar-bg-color'>
                    <div className='d-flex flex-row mb-1 mobile-justify-content orderbook-table-heading-section border-top-0'>
                      <div className='progress-table-1'>
                        <span className='orderbook-text-1'>Price(USDT)</span>
                      </div>
                      <div className='progress-table-2'>
                        <span className='orderbook-text-1'>Amount</span>
                      </div>
                      <div className='progress-table-3'>
                        <span className='orderbook-text-1'>Total</span>
                      </div>
                    </div>
                    <FuturesOrderBook
                      setPriceStatic={setPriceStatic}
                      viewOrderList={
                        orderBookData
                          ? orderListType === 'all' || orderListType === 'sell'
                            ? orderBookData?.asks
                              ? orderBookData?.asks
                                ?.slice(0, orderListType === 'all' ? 8 : 16)
                                .reverse()
                              : []
                            : orderBookData?.bids
                              ? orderBookData?.bids
                              : []
                          : []
                      }
                      orderListType={
                        orderListType === 'all' || orderListType === 'sell'
                          ? 'sell'
                          : 'buy'
                      }
                      viewLimit={orderListType === 'all' ? 8 : 16}
                      pairDetails={null}
                      reverse={'yes'}
                    />
                  </div>
                </div>
                {orderListType == 'all' && (
                  <div className='d-flex flex-row orderbook-table-heading-section'>
                    {pairDetails ? (
                      <div className='ps-2'>
                        <span
                          className={`${pairDetails?.data?.lastPrice >=
                            pairDetails?.prevPrice
                            ? 'color-green-futures'
                            : 'color-red-futures'
                            }`}
                        >
                          {pairDetails?.data?.lastPrice}
                        </span>
                      </div>
                    ) : (
                      ''
                    )}
                  </div>
                )}
                {orderListType == 'all' && (
                  <div className='trading-table-left-section exchange-progress-bar-bg-color '>
                    <FuturesOrderBook
                      orderListType={'buy'}
                      viewOrderList={orderBookData?.bids}
                      viewLimit={8}
                      pairDetails={null}
                      reverse={'no'}
                      setPriceStatic={setPriceStatic}
                    />
                  </div>
                )}
              </div>
            )}
          </div>
        ) : (
          <FuturesRecent
            tradeHistory={recentTradesData}
            pairsLoader={pairsLoader}
          />
        )}
      </div>
    </div>
  )
  const createSubAccount = async email => {
    const response = await createTradingAccount(email)
    if (response.status) {
      toast({ type: 'success', message: response.message })
      setUserProfile()
      setFuturesBalance()
    } else {
      toast({ type: 'error', message: response.message })
    }
  }
  return (
    <div className='bg-default text-white pb-0 overflow-hidden min-vh-100'>
      <PageTitleDes title={`Crypto Futures Trading | Leverage & Advanced Trading`} description={`Trade crypto futures with leverage and advanced tools. Maximize opportunities with secure and efficient trading features.`} />
      <NavbarOne setTheme={props.setTheme} theme={props.theme} />
      {/* <Helmet>
        <link
          rel='canonical'
          href='https://uniticexchange.com/futures/trade/BTCUSDT'
        />
      </Helmet> */}
      <div className='container-fluid pt-2 setFontRoboto'>
        <div className='first-panel-futures'>
          <div className='first-div-futures'>
            <div className='marquee-container'>
              <div
                className={`futures-trade-top-section d-flex justify-content-start align-items-center overflow-auto ${isOverflowingSecond ? '' : ''
                  }`}
                style={{ gap: '15px', whiteSpace: 'nowrap' }}
                ref={containerSecondRef}
              >
                <div>
                  <FuturesMenu
                    handleNavigation={handleNavigation}
                    pairsData={pairsData}
                    pairsLoader={pairsLoader}
                    pairName={pairName}
                    setOrderBookData={setOrderBookData}
                    updateFavPairs={updateFavPairs}
                    formatSymbolName={formatSymbolName}
                    pairDetails={pairDetails}
                    favs={favs}
                  />
                </div>
                <div>
                  <p
                    className={`${pairDetails?.data?.lastPrice >=
                      pairDetails?.prevPrice
                      ? 'color-green-futures'
                      : 'color-red-futures'
                      } fw-bold`}
                    style={{ fontSize: '1rem' }}
                  >
                    {pairDetails.data?.lastPrice}
                  </p>
                  {/* <p className={`color-green-futures fw-bold`} style={{ fontSize: '1rem' }}>{pair?.last}</p> */}
                </div>
                <div className='rate-part'>
                  <p>Mark Price</p>
                  <p>{pairDetails?.data?.markPrice}</p>
                </div>
                <div className='rate-part'>
                  <p>24h Volume</p>
                  <p className='futures-warning'>
                    {pairDetails?.data?.volume24h}
                  </p>
                </div>
                <div className='rate-part'>
                  <p>Open Interest</p>
                  {/* <p>{formatNumber(pairDetails?.data?.openInterest)} lot</p> */}
                  <p>{pairDetails?.data?.openInterest}</p>
                </div>
                <div className='rate-part'>
                  <p>Funding Rate</p>
                  <p
                    className={
                      pairDetails?.data?.fundingRate * 100 >= 0
                        ? 'color-green-futures'
                        : 'color-red-futures'
                    }
                  >
                    {((pairDetails?.data?.fundingRate || 0) * 100).toFixed(
                      4
                    )}
                    %
                  </p>
                </div>
                <div className='rate-part'>
                  <p>Funding Settlement</p>
                  <p>{formattedTime}</p>
                </div>
              </div>
              <div
                className={`futures-trade-top-section futures-first-part ${isOverflowing ? 'marquee-content' : ''
                  }`}
                ref={containerRef}
                style={{ display: !favs ? 'none' : '' }}
              >
                {favs &&
                  favs.map((dataSingle, index) => (
                    <p key={index}>
                      <span
                        onClick={() => handleNavigation(dataSingle?.symbol)}
                        className='cursor-pointer'
                      >
                        {showPairNameUsdt(dataSingle?.symbol, ' Perpetual/')}
                      </span>{' '}
                      <span
                        className={`${dataSingle?.lastPrice <= dataSingle?.markPrice
                          ? 'color-green-futures'
                          : 'color-red-futures'
                          } `}
                      >
                        {dataSingle?.lastPrice}
                      </span>
                    </p>
                  ))}
              </div>
              {/* <div className="futures-trade-top-section option-part">

                                <div onClick={() => setFirstOptionPart(0)}>
                                    <h6 className={`${firstOptionPart !== 0 ? 'futures-secondary' : ''} cursor-pointer`}>Chart</h6>
                                </div>
                                <div onClick={() => setFirstOptionPart(1)}>
                                    <h6 className={`${firstOptionPart !== 1 ? 'futures-secondary' : ''} cursor-pointer`}>Info</h6>
                                </div>
                                <div onClick={() => setFirstOptionPart(2)}>
                                    <h6 className={`${firstOptionPart !== 2 ? 'futures-secondary' : ''} cursor-pointer`}>Trading Data</h6>
                                </div>
                            </div> */}
            </div>
            <div className='row'>
              <div className='col-12 col-lg-8 col-xxl-9'>
                <div>
                  {firstOptionPart === 0 && (
                    <div id='tradingviewwidgetFutures'>
                      {pairName && !pairsLoader ? (
                        <TradingViewFutures
                          symbol={pairName}
                          theme={props.theme}
                          dec={pairDetails?.data?.priceFilter?.tickSize}
                        />
                      ) : (
                        <LoaderUnitic />
                      )}
                    </div>
                  )}
                  {firstOptionPart === 1 ? (
                    <Info />
                  ) : firstOptionPart === 2 ? (
                    <TradingData />
                  ) : null}
                </div>
                {/* {window.innerWidth > 991 ? myOrdersDiv : orderBooksDiv} */}
              </div>
              {orderBooksDiv}
            </div>
          </div>
          <div className='second-div-futures' style={{}}>
            <div style={{ height: '42px' }}></div>
            <FuturesTradeForm
              myProfile={myProfile}
              createSubAccount={createSubAccount}
              pairDetails={pairDetails}
              priceStatic={priceStatic}
              setPriceStatic={setPriceStatic}
              walletData={walletData}
              submitTrade={submitTradeWithAPI}
              handleClickOpenMarginMode={handleClickOpenMarginMode}
              handleClickOpenAdjust={handleClickOpenAdjust}
              crossMenu={crossMenu}
              xMenu={xMenu}
              tpPx={tpPx}
              setTpPx={setTpPx}
              slPx={slPx}
              setSlPx={setSlPx}
              futuresBalance={futuresBalance}
              fromSymbolName={fromSymbolName}
              handleClickOpenOrderConfirmation={
                handleClickOpenOrderConfirmation
              }
              trades={trades}
              getBaseAndTargetCurrency={getBaseAndTargetCurrency}
              amount={amount}
              setAmount={setAmount}
            />
            {/* <FuturesMarginRatio /> */}
          </div>
        </div>
        <div>{myOrdersDiv}</div>
      </div>
      {openOrderConfirmation && (
        <OrderConfirmation
          open={openOrderConfirmation}
          handleClickOpen={handleClickOpenOrderConfirmation}
          handleClose={handleCloseOrderConfirmation}
          tradeParams={tradeParams}
          formatSymbolName={formatSymbolName}
          submitTrade={submitTradeWithAPI}
          amount={amount}
          setAmount={setAmount}
        />
      )}
      {openModifyOrder && (
        <ModifyOrder
          open={openModifyOrder}
          handleClickOpen={handleClickOpenModifyOrder}
          handleClose={handleCloseModifyOrder}
        />
      )}
      {openModifyMargin && (
        <ModifyMargin
          open={openModifyMargin}
          handleClickOpen={handleClickOpenModifyMargin}
          handleClose={handleCloseModifyMargin}
        />
      )}
      {openAdjust && (
        <AdjustLeverage
          open={openAdjust}
          handleClickOpen={handleClickOpenAdjust}
          handleClose={handleCloseAdjust}
          xMenu={xMenu}
          setXMenu={setXMenu}
          pairDetails={pairDetails}
          pairName={pairName}
          formatSymbolName={formatSymbolName}
        />
      )}
      {openMarginMode && (
        <MarginMode
          open={openMarginMode}
          handleClickOpen={handleClickOpenMarginMode}
          handleClose={handleCloseMarginMode}
          crossMenu={crossMenu}
          setCrossMenu={setCrossMenu}
        />
      )}
    </div>
  )
}

export default FuturesTrade
